import PageMeta from '../components/common/PageMeta';
import GeneAnalysisWorkspace from '../components/systems/gene-analysis/GeneAnalysisWorkspace';
import { isGeneAnalysisPublicEnabled } from '../utils/config';

/**
 * 遺伝子解析。配列本体はブラウザの中だけで扱い、サーバーへは送らない（仕様 §1.1）。
 */
export default function GeneAnalysisManager() {
  const isPublic = isGeneAnalysisPublicEnabled();

  return (
    <>
      <PageMeta
        titleKey="geneAnalysis.title"
        descriptionKey="geneAnalysis.description"
        path="gene-analysis"
        robots={isPublic ? 'index,follow' : 'noindex,nofollow'}
      />
      <GeneAnalysisWorkspace />
    </>
  );
}
